// extracted by mini-css-extract-plugin
export default {"menuIconButton":"workflow-menu-module__menuIconButton__r2HBq6v","actionMenuOverlay":"workflow-menu-module__actionMenuOverlay__BPN4BqQ"};